module.exports = __webpack_public_path__ + "static/img/Luke.Davis.c360764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke.Davis.jpg
// module id = KMF4
// module chunks = 0